import React, { useEffect, useState } from 'react';
import Styles from './AdvanceSearch.module.scss';

const AdvanceSearch = ({ content, setAdvData, advData, setLcData, lcData }: any) => {
  const [addressData, setAddressData] = useState({
    street: '',
    city: '',
    postCode: '',
    houseNumber: '',
    concatedAddress: ''
  });
  const [concatedAddressState, setConcatedAddressState] = useState<string>('');
  const [btnClick, setBtnClick] = useState(false);
  const handleChange = (e: any) => {
    setAddressData({ ...addressData, [e.target.name]: e.target.value });
    const tempAddress = { ...addressData, [e.target.name]: e.target.value };
    updateConcatenatedAddress({ ...tempAddress });
  };
  const updateConcatenatedAddress = (data: any) => {
    let concatedAddress = '';
    if (
      data?.postCode !== '' &&
      data.city !== '' &&
      data.houseNumber !== '' &&
      data.street !== ''
    ) {
      concatedAddress =
        data.street + ' ' + data.houseNumber + ',' + ' ' + data.postCode + ' ' + data.city;

      setConcatedAddressState(concatedAddress);
    } else {
      setConcatedAddressState('');
    }
  };

  // handle check button
  const handleClick = () => {
    setBtnClick(true);
    if (concatedAddressState != '') {
      setAdvData({ ...advData, advAddress: addressData, fetchAdvCheck: true, advButton: true });
    }
  };

  // common error data
  const errorData = () => {
    return <p className={Styles['error-section']}>{content?.requiredErrText}</p>;
  };

  // cancel manual entry button click
  const handleManual = () => {
    setAdvData({
      ...advData,
      advOpen: false,
      advAddress: {},
      fetchAdvCheck: false,
      selectedAddress: ''
    });
    setLcData({ ...lcData, addressList: {}, selectedAddress: '' });
  };

  // setting the concat address
  useEffect(() => {
    setAddressData({ ...addressData, concatedAddress: concatedAddressState });
  }, [concatedAddressState]);

  useEffect(() => {
    advData?.advAddress?.concatedAddress &&
      setConcatedAddressState(advData.advAddress.concatedAddress);
    const newAddressData = {
      street: advData.advAddress?.street || '',
      city: advData.advAddress?.city || '',
      postCode: advData.advAddress?.postCode || '',
      houseNumber: advData.advAddress?.houseNumber || '',
      concatedAddress: advData.advAddress?.concatedAddress || ''
    };
    advData?.advAddress && setAddressData(newAddressData);
  }, []);

  return (
    <div className={Styles['adv-container']}>
      <div className='col-lg-9 col-md-9 col-sm-8'>
        {/* //first section */}
        <div className={`d-flex row ${Styles['sub-container']}`}>
          {/* //street */}
          <div className={`form-floating col-md-9 col-sm-9 ${Styles['street-container']}`}>
            <input
              required
              placeholder={content?.streetTxt + '*'}
              name='street'
              onChange={handleChange}
              value={addressData?.street}
              className={`form-control ${
                btnClick && addressData?.street === '' && Styles['border-error']
              }
                `}
            />
            <label htmlFor='address'>{content?.streetTxt + '*'}</label>
            {btnClick && addressData?.street === '' && errorData()}
          </div>
          {/* house no */}
          <div className={`form-floating col-md-3 col-sm-3`}>
            <input
              required
              placeholder={content?.noTxt + '*'}
              name='houseNumber'
              onChange={handleChange}
              value={addressData?.houseNumber}
              className={`form-control ${
                btnClick && addressData?.houseNumber === '' && Styles['border-error']
              }
                `}
            />
            <label htmlFor='address'>{content?.noTxt + '*'}</label>
            {btnClick && addressData?.houseNumber === '' && errorData()}
          </div>
        </div>

        {/* //second section */}
        <div className={`d-flex row ${Styles['sub-container2']}`}>
          {/* zip code */}
          <div className={`form-floating col-md-3 col-sm-3`}>
            <input
              required
              placeholder={content?.zipTxt + '*'}
              name='postCode'
              onChange={handleChange}
              value={addressData?.postCode}
              type='number'
              className={`form-control ${
                btnClick && addressData?.postCode === '' && Styles['border-error']
              }
                `}
            />
            <label htmlFor='address'>{content?.zipTxt + '*'}</label>
            {btnClick && addressData?.postCode === '' && errorData()}
          </div>
          {/* city */}
          <div className={`form-floating col-md-9 col-sm-9`}>
            <input
              required
              placeholder={content?.cityTxt + '*'}
              name='city'
              onChange={handleChange}
              value={addressData?.city}
              className={`form-control ${
                btnClick && addressData?.city === '' && Styles['border-error']
              }
                `}
            />
            <label htmlFor='address'>{content?.cityTxt + '*'}</label>
            {btnClick && addressData?.city === '' && errorData()}
          </div>
        </div>
      </div>
      <div className={`col-md-3 col-lg-3 col-sm-4 ${Styles['btn-container']}`}>
        <button
          type='button'
          className={Styles['primary-button']}
          disabled={false}
          onClick={handleClick}
        >
          {content?.checkBtn}
        </button>
        <div className={Styles['link-btn']} onClick={handleManual}>
          {content?.cancelManualTxt}
        </div>
      </div>
    </div>
  );
};

export default AdvanceSearch;
